import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CheckoutData {
    email?: string;
    name?: string;
    selectedPrice?: string;
    paymentMethod?: string;
    subscriptionStatus?: boolean;
    timestamp?: string;
}

interface FunnelStore {
    funnel: Record<string, any>; // funnelId -> funnel object
    newsLetterStatus: boolean;
    checkoutData: CheckoutData;
    addChoice: (choice: {
        stepIndex: string,
        content: any,
    }) => void;
    clearChoices: () => void;
    getFunnel: (funnelId: string) => any;
    getStatus: () => any;
    getChoiceByStepId: (stepId: string) => any | undefined;
    updateMailStatus: (status: boolean) => any;
    saveCheckoutData: (data: CheckoutData) => void;
    getCheckoutData: () => CheckoutData;
    clearCheckoutData: () => void;
    updateCheckoutField: (field: keyof CheckoutData, value: any) => void;
    getAllFunnelData: () => any;
    setFunnel: (funnel: any) => void;
}

export const useFunnelStore = create<FunnelStore>()(
    persist(
        (set, get) => ({
            funnel: {},
            newsLetterStatus: false,
            checkoutData: {},
            updateMailStatus:(status: boolean) => set((state) => {
                return {
                    funnel: {
                        ...state.funnel,
                    },
                    newsLetterStatus: status
                };
            }),
            getStatus: () => {
                const state = get();
                return state.newsLetterStatus;
            },
            addChoice: (choice) => set((state) => {
                return {
                    funnel: {
                        ...state.funnel,
                        [choice.stepIndex]: choice.content
                    }
                };
            }),
            clearChoices: () => set({
                funnel: {}
            }),
            getFunnel: (funnelId: string) => {
                const state = get();
                return state.funnel;
            },
            getChoiceByStepId: (stepIndex: string) => {
                const state = get();
                if(stepIndex)
                    return state.funnel[Number(stepIndex)]
            },
            saveCheckoutData: (data: CheckoutData) => set((state) => ({
                checkoutData: {
                    ...state.checkoutData,
                    ...data,
                    timestamp: new Date().toISOString()
                }
            })),
            getCheckoutData: () => {
                const state = get();
                return state.checkoutData;
            },
            clearCheckoutData: () => set({
                checkoutData: {}
            }),
            updateCheckoutField: (field: keyof CheckoutData, value: any) => set((state) => ({
                checkoutData: {
                    ...state.checkoutData,
                    [field]: value
                }
            })),
            getAllFunnelData: () => {
                const state = get();
                return {
                    funnelSteps: state.funnel,
                    newsLetterStatus: state.newsLetterStatus,
                    checkoutData: state.checkoutData,
                    timestamp: new Date().toISOString()
                };
            },
            setFunnel: (funnel: any) => set((state) => ({
                funnel: {
                    ...state.funnel,
                    ...funnel,
                }
            })),
        }),
        {
            name: 'user-choices-storage',
            version: 1,
            // Persist choices, newsletter status, and checkout data
            partialize: (state) => ({
                funnel: state.funnel,
                newsLetterStatus: state.newsLetterStatus,
                checkoutData: state.checkoutData
            }),
        }
    )
);
